import { BpmnModel, BpmnModelHelper, ExtensionMethod, MexExpression, ServiceTask } from "@edp-pmf/bpmn-model";
import { SplitActivity } from "@edp-bpm/bpmn-common-model";

export class SplitBillActivity extends SplitActivity {
    static Clr_Type_ID: string = "bpm.SplitBillActivity";
    ClrTypeID: string = SplitBillActivity.Clr_Type_ID;

    constructor(model: BpmnModel) {
        super(model);
    }

    ResetBeforeLoadFrom() {
        super.ResetBeforeLoadFrom();
    }

    ConvertToJsonObject(): any {
        let obj = super.ConvertToJsonObject();
        return obj;
    }

    LoadFromJsonObject(obj: any) {
        super.LoadFromJsonObject(obj);
    }

    NewInstance(): SplitBillActivity {
        return new SplitBillActivity(this.Model);
    }

    clone(): SplitBillActivity {
        const c = super.clone() as SplitBillActivity;
        c.Name = this.Name;
        c.NameLanguage = this.NameLanguage && {
            ...this.NameLanguage,
        };

        return c;
    }
}
BpmnModelHelper.RegisterElementType(new SplitBillActivity(new BpmnModel()));